import { Operator, OPERATORS } from "../../shared/models/operators";

export class Rule {
  id: number
  fieldName: string;
  operator: Operator;
  values: string[] = [];
}
